import Immutable from 'seamless-immutable';

import {
    BUNDLES_REQUEST,
    BUNDLES_SUCCESS,
    BUNDLES_ERROR, BUNDLES_UPDATE_SUCCESS, BUNDLES_UPDATE_REQUEST,
} from 'Actions/bundles';

const INITIAL_STATE = Immutable({
    data: {},
    failed: false,
    loaded: false,
    loading: false,
});

export default function bundles (state = INITIAL_STATE, action) {
    switch (action.type) {
        case BUNDLES_UPDATE_REQUEST:
        case BUNDLES_REQUEST:
            return state.merge({
                loaded: false,
                loading: true,
            });

        case BUNDLES_SUCCESS:
            return state.merge({
                data: action.data || {},
                loaded: true,
                loading: false,
            });

        case BUNDLES_UPDATE_SUCCESS:
            return state.merge({
                loading: false,
            });

        case BUNDLES_ERROR:
            return state.merge({
                failed: true,
                loaded: true,
                loading: false,
            });

        default:
            return state;
    }
}
